import React from 'react';
import { Circle, Text, Group } from 'react-konva';
import PropTypes from 'prop-types';
import COLORS from 'utils/constants/colors';
const { WHITE, GREY_01 } = COLORS;

const CircleWithText = ({
  x,
  y,
  index,
  handleDragStartPoint,
  handleDragEndPoint,
  markerDraggable,
  radius,
  textValue,
  textRef,
  startPointAttr,
  seqNum,
}) => {
  return (
    <Group
      x={x}
      y={y}
      key={index}
      onDragStart={handleDragStartPoint}
      onDragEnd={handleDragEndPoint}
      draggable={markerDraggable}
      {...startPointAttr}
    >
      <Circle
        radius={radius}
        fill={textValue ? GREY_01 : WHITE}
        stroke={textValue ? WHITE : GREY_01}
        strokeWidth={1}
      />

      <Text
        ref={ref => (textRef.current[index] = ref)}
        text={textValue ? textValue : seqNum}
        fill={WHITE}
        offsetY={textRef?.current[index]?.textHeight / 2}
        offsetX={textRef?.current[index]?.textWidth / 2}
      />
    </Group>
  );
};

CircleWithText.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  seqNum: PropTypes.number,
  index: PropTypes.number,
  handleDragStartPoint: PropTypes.func,
  handleDragEndPoint: PropTypes.func,
  markerDraggable: PropTypes.bool,
  radius: PropTypes.number,
  textValue: PropTypes.number,
  textRef: PropTypes.object,
  startPointAttr: PropTypes.object,
};

export default CircleWithText;
